
import { computed, defineComponent, getCurrentInstance } from 'vue';

export default defineComponent({
    components: {},
    props: {
        userName: {
            type: String,
            default: () => '',
        },
        avatarUrl: {
            type: String,
            default: () => '',
        },
        publishTime: {
            type: Number,
            default: () => 0,
        },
        verifiedNum: {
            type: Number,
            default: 0,
        },
    },
    emits: ['onAvatarOrNameClick'],
    setup(props, { emit }) {
        const { proxy } = getCurrentInstance() || {};

        const verifiedUserIcon = computed(() => {
            if (props.verifiedNum === 3) {
                return 'https://cdn-static.kwai.net/kos/s101/nlav11312/pwa-images/legalize_firm.png';
            }
            return 'https://cdn-static.ap4r.com/kos/s101/nlav11312/pwa-images/legalize_personal.png';
        });

        const onAvatarOrNameClick = () => {
            emit('onAvatarOrNameClick');
        };

        function formatTimestamp(timestamp?: number) {
            if (!timestamp || timestamp === 0) {
                return '';
            }

            const now = Date.now();
            const oneDay = 24 * 60 * 60 * 1000;
            const timeDiff = now - timestamp;

            if (timeDiff < oneDay) {
                return proxy?.$root?.$t('one_hour_ago') ?? '';
            }

            // 判断是否在七天内
            if (timeDiff < 7 * oneDay) {
                const diffDays = Math.floor(timeDiff / oneDay);
                return proxy?.$root?.$t('days_ago', { day: diffDays }) ?? '';
            }

            // 7天外
            return proxy?.$root.$t('days_ago', { day: 7 }) ?? '';
        }

        const publishTimeFormate = computed(() => {
            return formatTimestamp(props.publishTime);
        });

        return {
            publishTimeFormate,
            verifiedUserIcon,

            onAvatarOrNameClick,
        };
    },
});
